export default __webpack_public_path__ + "static/media/GraftCafe-6.456fc479.jpg";